import WheatTortillaProduct from 'models/WheatTortillaProduct'

export const packagingInitialState = {
  category: WheatTortillaProduct.category,
  subCategory: WheatTortillaProduct.subCategory,
  Size: WheatTortillaProduct.Size,
}
